import { IDriverCreate, IDriverListSearch, IEditDriverPayload, IGetDriverDetails, IGetDriverList } from "../../../types/master/driverInterface";
import { DriverActionTypes, DriverActions } from "../../actionTypes/master/driverActionType";

export const createDriver = (user: IDriverCreate): DriverActionTypes => ({
  type: DriverActions.CREATE_DRIVER,
  payload: user
})

export const getDriverList = (payload: IDriverListSearch): DriverActionTypes => ({
  type: DriverActions.GET_DRIVER_LIST,
  payload,
});

export const setDriverList = (branchList: Array<IGetDriverList>) : DriverActionTypes => ({
  type: DriverActions.SET_DRIVER_LIST,
  payload: branchList
})

export const setDriverListPageCount = (payload:number): DriverActionTypes => ({
  type: DriverActions.SET_DRIVER_LIST_PAGE_COUNT,
  payload
})

export const getDriverDataById = (id: number): DriverActionTypes => ({
  type: DriverActions.GET_DRIVER_DATA_BY_ID,
  payload: id
})

export const setDriverDataById = (payload: IGetDriverDetails): DriverActionTypes => ({
  type: DriverActions.SET_DRIVER_DATA_BY_ID,
  payload
})

export const editDriver = (payload: IEditDriverPayload): DriverActionTypes => ({
  type: DriverActions.EDIT_DRIVER_DATA_BY_ID,
  payload,
});